import { sharedHeaders } from "../utils/constants"

const getProducts = {
  "type": "endpoint",
  "method": "get",
  "title": "Get Products",
  "path": "/v1/products",
  "description": "Get available insurance products with optional filtering by resort, activity, and duration",
  "request": {
    "headers": [
      ...sharedHeaders
    ],
    "query": [
      {
        "key": "resort",
        "required": false,
        "type": "string",
        "description": "Resort ID to filter products by",
        "example": "0zOzhkIXNKM0DRjqGj0R"
      },
      {
        "key": "activity",
        "required": false,
        "type": "string",
        "description": "Activity ID to filter products by",
        "example": "puaQc2Y44zU16iiTeGob"
      },
      {
        "key": "duration",
        "required": false,
        "type": "string",
        "description": "Duration ID to filter products by",
        "example": "rkGTHb9cr39fx4NUFAYi"
      }
    ]
  },
  "responses": {
    "200": {
      "description": "Successful response",
      "content": {
        "application/json": {
          "schema": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/ProductSelectorItemDto"
            }
          }
        }
      }
    },
    "400": {
      "description": "Bad Request"
    },
    "401": {
      "description": "Unauthorized"
    },
    "500": {
      "description": "Internal Server Error"
    }
  },
  "components": {
    "schemas": {
      "PRODUCT_PRICE_UNIT": {
        "description": "Possible values: person, person_per_day.",
        "type": "string",
        "enum": [
          "person",
          "person_per_day"
        ]
      },
      "ProductSelectorItemDto": {
        "type": "object",
        "properties": {
          "product_id": {
            "type": "string",
            "description": "ID of product",
            "example": "rMYNCOjLzlwABlFLY5Cq"
          },
          "documents": {
            "type": "object",
            "properties": {
              "cg": {
                "type": "string",
                "description": "URL to terms and conditions document",
                "example": "https://example.com/terms-and-conditions.pdf"
              },
              "ipid": {
                "type": "string",
                "description": "URL to insurance product information document",
                "example": "https://example.com/insurance-product-information.pdf"
              }
            },
            "required": [
              "cg",
              "ipid"
            ]
          },
          "activity": {
            "type": "string",
            "description": "Activity ID",
            "example": "puaQc2Y44zU16iiTeGob"
          },
          "activityLabel": {
            "type": "string",
            "description": "Localized activity title",
            "example": "Downhill skiing, snowboarding, other on-snow activities (snowshoeing, sledding...)"
          },
          "duration": {
            "type": "string",
            "description": "Duration ID",
            "example": "rkGTHb9cr39fx4NUFAYi"
          },
          "durationLabel": {
            "type": "string",
            "description": "Localized duration title",
            "example": "Day(s)"
          },
          "name": {
            "type": "string",
            "description": "Localized product name",
            "example": "ASSURGLISSE"
          },
          "price": {
            "type": "number",
            "description": "Product price per unit",
            "example": 2.7
          },
          "price_currency": {
            "type": "string",
            "description": "Currency of the product price in ISO 4217 format",
            "example": "EUR"
          },
          "price_unit": {
            "$ref": "#/components/schemas/PRODUCT_PRICE_UNIT",
            "description": "Price unit indicating how the price is applied Possible values: person, person_per_day.",
            "example": "person_per_day"
          },
          "resort": {
            "type": "string",
            "description": "Resort ID",
            "example": "0zOzhkIXNKM0DRjqGj0R"
          },
          "resortLabel": {
            "type": "string",
            "description": "Localized resort name",
            "example": "Le Mont Dore"
          },
          "sale_period": {
            "type": "object",
            "properties": {
              "start": {
                "type": "string",
                "description": "Sale start date in DD/MM format",
                "example": "01/11"
              },
              "end": {
                "type": "string",
                "description": "Sale end date in DD/MM format",
                "example": "30/04"
              }
            },
            "required": [
              "start",
              "end"
            ]
          }
        },
        "required": [
          "product_id",
          "documents",
          "activity",
          "activityLabel",
          "duration",
          "durationLabel",
          "name",
          "price",
          "price_currency",
          "resort",
          "resortLabel",
          "sale_period"
        ]
      },
      "ProductsRequestQuery": {
        "type": "object",
        "properties": {
          "resort": {
            "type": "string",
            "description": "Resort ID to filter products by",
            "example": "0zOzhkIXNKM0DRjqGj0R"
          },
          "activity": {
            "type": "string",
            "description": "Activity ID to filter products by",
            "example": "puaQc2Y44zU16iiTeGob"
          },
          "duration": {
            "type": "string",
            "description": "Duration ID to filter products by",
            "example": "rkGTHb9cr39fx4NUFAYi"
          }
        }
      }
    }
  }
}

export { getProducts }
